import { InputLabel } from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import classes from "../../../styles/CreateFormStyle";

export default function CheckInFormSelect({ register }: any) {
  return (
    <Box sx={classes.select}>
      <FormControl>
        <InputLabel sx={classes.select1} id="demo-simple-select-label">Select</InputLabel>
        <Select
          name="type"
          label="Age"

          {...register("type")}

        // IconComponent={<ArrowDropDownRoundedIcon />}
        >
          <MenuItem value={"TEXTFIELD"} sx={classes.selectItem}>
            Text Field
          </MenuItem>
          <MenuItem value={"TEXTAREA"} sx={classes.selectItem}>
            Text Area
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
